<template>
  <div class="intake-sidebar d-flex flex-column">
    <div class="intake-sidebar__rooms">
      <button
        v-for="(address, addressIndex) in addresses"
        :key="addressIndex"
        :class="`${addressIndex === selectedAddressIndex ? 'is-active' : ''} btn--reset`"
        type="button"
        @click="() => setSelectedAddressIndex(addressIndex)"
      >
        <strong class="d-block">
          {{ addressTypeToText(address.type) }}
        </strong>

        <div
          v-if="address.street && address.house_number && address.city"
          class="font-size-xs font-weight-normal text-muted mt-1"
        >
          {{ address.street }} {{ address.house_number }}, {{ address.city }}
        </div>
      </button>
    </div>

    <div class="intake-sidebar__add">
      <div class="custom-select flex-grow-1 mr-1">
        <select v-model="addressType">
          <option value="">Selecteer een type</option>

          <option
            v-for="addressType in addressTypes"
            :key="addressType.id"
            :value="addressType.value"
          >
            {{ addressType.title }}
          </option>
        </select>
      </div>

      <button
        class="btn btn--primary btn--sm btn--icon-only"
        type="button"
        @click="() => addAddress(addressType)"
        :disabled="addressType === ''"
      >
        +
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      addresses: 'address/addresses',
      selectedAddressIndex: 'address/selectedAddressIndex',
    }),
  },

  data() {
    return {
      addressType: '',
      addressTypes: [{
        id: 1,
        title: 'Laadadres',
        value: 1,
      }, {
        id: 2,
        title: 'Losadres',
        value: 2,
      }],
    };
  },

  methods: {
    ...mapMutations({
      addAddress: 'address/addAddress',
      setSelectedAddressIndex: 'address/setSelectedAddressIndex',
    }),

    addressTypeToText(type) {
      if (type === 1) {
        return 'Laadadres';
      }

      if (type === 2) {
        return 'Losadres';
      }

      return '';
    },
  },
};
</script>
